import Matrix from 'ml-matrix';
import { reimAbsolute, reimAutoPhaseCorrection, reimFFT, reimPhaseCorrection, } from 'ml-spectra-processing';
import { apodization, } from '../../../apodization/apodization';
import { zeroFilling } from './zeroFilling';
export function fftIndirectDimension(data, options) {
    const reData = Matrix.checkMatrix(data.re);
    const imData = Matrix.checkMatrix(data.im);
    const nbRows = reData.rows;
    const nbColumns = reData.columns;
    const { zeroFilling: zeroFillingF1 } = options;
    const { factor: f1Factor = 2 } = zeroFillingF1 || {};
    const nbPointsF1 = zeroFillingF1?.nbPoints || 2 ** Math.round(Math.log2(nbRows * f1Factor));
    const { apodization: apodizationF1 } = options;
    let { ph0: ph0F1, ph1: ph1F1, mode: pcModeF1, } = options.phaseCorrection || {};
    const reResult = new Matrix(nbPointsF1, nbColumns);
    const imResult = new Matrix(nbPointsF1, nbColumns);
    for (let i = 0; i < nbColumns; i++) {
        const { re: aRe, im: aIm } = apodization({
            re: reData.getColumn(i),
            im: imData.getColumn(i),
        }, apodizationF1);
        const newRe = [];
        const newIm = [];
        if (options.fnMode === 'echo') {
            for (let j = 0; j < aRe.length; j += 2) {
                newRe.push(aRe[j]);
                newIm.push(aRe[j + 1]);
            }
        }
        else {
            for (let j = 0; j < aRe.length; j++) {
                newRe.push(aRe[j]);
                newIm.push(-aIm[j]);
            }
        }
        let transformed = reimFFT(zeroFilling({
            re: newRe,
            im: newIm,
        }, { digitalFilterValue: 0, nbPoints: nbPointsF1 }), { applyZeroShift: true });
        let { re, im } = transformed;
        if (options.phaseCorrection?.mode === 'mc') {
            re = reimAbsolute({ re, im });
            im = new Float64Array(im.length);
        }
        if (pcModeF1 === 'pk') {
            if (i === 0 && ph0F1 === undefined && ph1F1 === undefined) {
                //here we can improve it by checking if the experiment is phase sensitive.
                const phased = reimAutoPhaseCorrection({ re, im }, { magnitudeMode: false });
                ph0F1 = phased.ph0;
                ph1F1 = phased.ph1;
            }
            if (ph0F1 !== undefined && ph1F1 !== undefined) {
                Object.assign(transformed, reimPhaseCorrection(transformed, (ph0F1 * Math.PI) / 180, (ph1F1 * Math.PI) / 180));
            }
        }
        reResult.setColumn(i, re);
        imResult.setColumn(i, im);
    }
    return {
        re: reResult,
        im: imResult,
    };
}
//# sourceMappingURL=fftIndirectDimension.js.map